$(function(){
  $('.js-accordion').click(function(){
    $(this).toggleClass('is-active')
    $(this).next('dd').stop().slideToggle()
  })
})